<footer class="main-footer">
  <strong>Copyright &copy; <span>{{ curYear }}</span> <a href="http://adminlte.io"> Fresh Milk Software Ltd</a>.</strong>
  All rights reserved.
  <div class="float-right d-none d-sm-inline-block">
    <b>Version</b> 1.0.0
  </div>
</footer>
